export class DbGear{
    Id: number;
    Name: string;
    Description: string;
    Properties: string;
    TypeId: number;
    ParentId: number;
}
